import React, {useState} from "react";

import Page from "components/Page";
import IndicatorsList from "./List";
import {useNavigate} from "react-router";
import {SelectIndicator} from "../../components/Select";
import {useUser} from "../../store/providers/app";
import {toast} from "react-toastify";

const Collect = () => {

    const navigate = useNavigate();
    const { user } = useUser()

    const [selectedIndicator, setSelectedIndicator] = useState(null);

    const changeSelect = (newValue, {action}) => {
        switch (action.action) {
            case 'select-option':
                setSelectedIndicator(newValue)
                navigate('/collect/indicator/edit/' + newValue.value)
                break
            case 'clear':
                break
            default:
                return
        }
    };

    if (user.profile !== 1) {
        toast.error('Você não tem permissão para acessar esta área!');
        navigate('/')
    }

    return (
        <Page
            label="Indicadores"
            icon="bi bi-pencil-square"
        >

            <div className="card mt-3 border-0 shadow-sm">
                <div className="card-body">
                    <SelectIndicator changeSelect={changeSelect} selected={selectedIndicator}/>
                </div>
            </div>

            <IndicatorsList />
        </Page>

    );
}

export default Collect
